// For IE11
// https://stackoverflow.com/questions/56686472/how-to-setup-a-vue-cli-with-vuetify-project-to-run-with-ie-11
import 'core-js/stable'
import Vue from 'vue'

// icons
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import vuetify from '@/plugins/vuetify'
import '@/plugins/electron'
import store from '@/plugins/vuex'
import router from '@/config/router'
import App from './App.vue'
import i18n from './GlobalResource'
import AppSettings from 'arc4u.framework.js/token/AppSettings'
import IAppSettings from 'arc4u.framework.js/token/IAppSettings'
import CreatePrincipal from 'arc4u.framework.js/Security/AppPrincipalFactory'
import ClaimsTokenFiller from 'arc4u.framework.js/Security/Principal/ClaimsProxy'
import ClaimsProfileFiller from 'arc4u.framework.js/Security/Principal/ClaimsProfileFiller'
import ClaimsAuthorizationFiller from 'arc4u.framework.js/Security/Principal/ClaimsAuthorizationFiller'
import * as $ from 'jquery'
import { VueReCaptcha } from 'vue-recaptcha-v3'


const callback: () => void = () => {
  new Vue({
    vuetify,
    // @ts-ignore
    store,
    router,
    render: h => h(App),
    i18n
  }).$mount('#app');
};


Vue.config.productionTip = false

CreatePrincipal.ClaimsFiller = new ClaimsTokenFiller();
CreatePrincipal.UserProfileFiller = new ClaimsProfileFiller();
CreatePrincipal.AuthorizationFiller = new ClaimsAuthorizationFiller();

const settings: IAppSettings = new AppSettings();

$.getJSON('./tokenconfig.json').then((config) => {
  settings.Initialize('OAuth', config);
  const recaptchaKey = settings.Values.filter((v: { Key: string }) => v.Key === 'ReCaptcha')[0].Value
  Vue.use(VueReCaptcha, { siteKey: recaptchaKey })
  callback();
});

